import { Subject } from 'rxjs';
/**
 * Service to force updates at the Aspera App Wrapper level (top level)
 */
export class ForceUpdateService {
    constructor() {
        /** Force update subject */
        this.userActivity = new Subject();
    }
    get updateSubscription() {
        return this.userActivity.asObservable();
    }
    triggerUpdate() {
        this.userActivity.next(true);
    }
}
/** The shared force update service */
export const forceUpdate = new ForceUpdateService();
